import React from 'react';
import { cn } from '../../lib/utils';

export function InfoRow({ label, value, color = "#00d9ff", shrink }: { label: string, value: React.ReactNode, color?: string, shrink?: boolean }) {
  return (
    <div className="flex justify-between items-center text-[10px] md:text-[12px]">
      <span className="text-[#666666] uppercase tracking-[1px] shrink-0 mr-2">{label}</span>
      <span style={{ color }} className={cn("font-bold", shrink ? "truncate" : "")}>{value}</span>
    </div>
  );
}
